export default __webpack_public_path__ + "static/Austrian-Red-Cross-ceb81440ff4bc6efd01cecfc360b3aef.png";